import React, { createContext, useContext, useState, useCallback } from 'react';

const NoteSelectionContext = createContext();

export const NoteSelectionProvider = ({ children }) => {
  const [selectedNote, setSelectedNote] = useState(null);
  const [homeReset, setHomeReset] = useState(false);

  const selectNote = useCallback(note => {
    setSelectedNote(note);
    setHomeReset(false);
  }, []);

  const deselectNote = useCallback(() => {
    setSelectedNote(null);
    setHomeReset(false);
  }, []);

  const triggerHomeReset = useCallback(() => {
    setSelectedNote(null);
    setHomeReset(true);
  }, []);

  return (
    <NoteSelectionContext.Provider value={{ selectedNote, selectNote, deselectNote, homeReset, triggerHomeReset }}>
      {children}
    </NoteSelectionContext.Provider>
  );
};

export const useNoteSelection = () => useContext(NoteSelectionContext);
